import React from 'react'
import styles from './index.module.scss'

const Card = () => (
  <div data-testid="pre-loader" className={styles.ObjectPreloader}>
    <div className={styles.LoaderImage} />
  </div>
)
export default Card
